import request from "./request";

const api = {
  getServerTop: "server/getServerTop",
  getServerList: "server/getServerList",
  getServer: "server/getServer",
  buyServer: "server/buyServer",
  getServerIncome: "server/getServerIncome",
};
export default {
  buyServer(parameter) {
    return request({
      url: api.buyServer,
      method: "POST",
      data: parameter,
    });
  },
  getServerIncome(parameter) {
    return request({
      url: api.getServerIncome,
      method: "POST",
      data: parameter,
    });
  },
  getServer(parameter) {
    return request({
      url: api.getServer,
      method: "POST",
      data: parameter,
    });
  },
  getServerTop(parameter) {
    return request({
      url: api.getServerTop,
      method: "POST",
      data: parameter,
    });
  },
  getServerList(parameter) {
    return request({
      url: api.getServerList,
      method: "POST",
      data: parameter,
    });
  },
};
